/*
 If enabled logs all events to the browser console.
 Helpful when debugging events
 */
import { LABEL_GENERIC_TASK } from "../events";

const createListener = ({
  enabled
}) => (event, getContext) => {
  if (!enabled) return;

  const logEvent = title => {
    console.groupCollapsed("%c Fired telemetry event: ".concat(title), 'color: teal');
    Object.entries({ ...event,
      ...getContext()
    }).sort((entryA, entryB) => entryA[0].localeCompare(entryB[0])).forEach(entry => console.log(entry[0], ':', entry[1]));
    console.groupEnd();
  };

  switch (event.type) {
    case LABEL_GENERIC_TASK:
      logEvent([event.task, event.taskId].filter(t => !!t).join(','));
      break;

    default:
      logEvent(event.type);
  }
};

export default createListener;